import { Banner } from '../types/admin';

export const banners: Banner[] = [
  {
    id: 'b-suv',
    kind: 'Lanzamiento',
    hook: 'Subite a la altura',
    title: 'LOS SUV',
    subtitle: 'Más espacio, más presencia, más aventura. Elegí el SUV que te queda perfecto y simulá tu cuota en segundos.',
    ctaLabel: 'Quiero mi SUV',
    link: '/catalogo?body=SUV',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8ea258c0-6e3f-4cdf-932b-ea012fc59eeb.jpg',
    active: true,
    startsAt: '2026-10-01',
    endsAt: '2027-03-31',
  },
  {
    id: 'b-sedan',
    kind: 'Campaña',
    hook: 'Elegancia que se nota',
    title: 'LOS SEDÁN',
    subtitle: 'Llegá a todos lados con estilo. Confort de primera para vos y tu familia, con financiación a tu medida.',
    ctaLabel: 'Ver los sedán',
    link: '/catalogo?body=Sedán',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d90f1407-7ec5-442b-9ec6-903260fddbbc.jpg',
    active: true,
    startsAt: '2026-10-01',
    endsAt: '2027-03-31',
  },
  {
    id: 'b-hatch',
    kind: 'Campaña',
    hook: 'Tu primer 0 km te espera',
    title: 'LOS HATCHBACK',
    subtitle: 'Ágiles, económicos y con onda. La forma más fácil de estrenar auto este año.',
    ctaLabel: 'Ver los hatchback',
    link: '/catalogo?body=Hatchback',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d1240075-467c-4010-97e4-e983cadff05f.jpg',
    active: true,
    startsAt: '2026-10-01',
    endsAt: '2027-03-31',
  },
  {
    id: 'b-pickup',
    kind: 'Campaña',
    hook: 'Sin límites',
    title: 'LAS PICK-UPS',
    subtitle: 'Fuerza para trabajar de lunes a viernes y para escaparte el fin de semana. Encontrá la tuya según tu anticipo.',
    ctaLabel: 'Ver las pick-ups',
    link: '/catalogo?body=Pick-up',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/26b0232b-1c57-4ee2-920a-2eddab0ab54f.jpg',
    active: true,
    startsAt: '2026-10-01',
    endsAt: '2027-03-31',
  },
  {
    id: 'b-novedades',
    kind: 'Novedad',
    hook: 'Recién llegados',
    title: 'NOVEDADES',
    subtitle: 'Lanzamientos y nuevas versiones antes que nadie. Enterate primero y reservá tu lugar.',
    ctaLabel: 'Ver novedades',
    link: '/catalogo',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/175e525b-556d-45f6-95fc-048e65dce724.jpg',
    active: true,
    startsAt: '2026-10-01',
    endsAt: '2027-03-31',
  },
  {
    id: 'b-explora',
    kind: 'Novedad',
    hook: 'Todas las marcas, un solo lugar',
    title: 'EXPLORÁ',
    subtitle: 'Compará precios, anticipos y cuotas de todas las marcas sin moverte de tu casa. Tu próximo 0 km está acá.',
    ctaLabel: 'Explorar 0 km',
    link: '/catalogo',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cb361fac-3f05-4576-a84b-52933142491b.jpg',
    active: true,
    startsAt: '2026-10-01',
    endsAt: '2027-03-31',
  },
];
